import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Chart } from '../../shared/charts/chart';
import { noStatsToShow, Stats } from '../stats.model';

@Component({
  selector: 'cc-activity-overview-chart',
  templateUrl: './activity-overview-chart.component.html',
  styleUrls: ['./activity-overview-chart.component.scss']
})
export class ActivityOverviewChartComponent implements OnInit, OnChanges {
  @Input() public stats: Stats;

  public dataAvailable = false;

  public chartData: Chart[] = [
    {
      labels: ['Impressions', 'Leads', 'Contacted', 'Successes'],
      data: [0, 0, 0, 0],
      label: 'Popup conversion',
      backgroundColor: ['#50A89D', '#1EC1AA', '#6AE2D2', '#B3E3DD']
    }
  ];

  constructor() {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    this.dataAvailable = this.stats && !noStatsToShow(this.stats);

    if (this.dataAvailable) {
      this.changeChartData(this.stats);
    } else {
      this.showNoDataAvailable();
    }
  }

  private showNoDataAvailable() {
    // 'random' data
    this.changeChartData({
      contacted: 119,
      successes: 68,
      leads: 191,
      impressions: 287
    });
  }

  private changeChartData(stats: Stats) {
    const copy: Chart[] = [...this.chartData];
    copy[0].data = [stats.impressions, stats.leads, stats.contacted, stats.successes];
    this.chartData = copy;
  }
}
